






















































export interface ITab {
  id: string;
  value: string;
  icon?: string;
  [key: string]: any; // Allow additional properties
}

import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ContextMenu from "@/components/utility/ContextMenu.vue";

@Component({ components: { ContextMenu } })
export default class TabLayout extends Vue {
  tab = 0;

  @Prop()
  tabs!: ITab[];

  @Prop()
  isLoading!: boolean;

  @Watch("tab")
  onTabChange(newTab: number) {
    this.$emit("update:tab", this.tabs[newTab]);
  }

  get defaultIcon() {
    return "mdi-tag-outline";
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
